import React, { useEffect, useRef, useState } from "react";
import { getApiCall, postApiCall, postFormApiCall } from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import {
  FormControl,
  MenuItem,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Select } from "@material-ui/core";
import { CircleSpinnerOverlay } from "react-spinner-overlay";

const LevelPage = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [levelID, setLevelID] = useState("");

  const [loading, setLoading] = useState(false);

  const [classList, setClassList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [className, setClassName] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [levelName, setLevelName] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const classes = await getApiCall("classes/get-all");
    setClassList(classes.data);

    const res = await getApiCall("levels/get-all");
    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const fileInputRef = useRef(null);
  const imageFileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append("id", levelID);
    formData.append("class_id", className);
    formData.append("module_id", moduleName);
    formData.append("names", levelName);

    let res = await postFormApiCall("levels/add", formData);

    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    setLevelID("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (imageFileInputRef.current) {
      imageFileInputRef.current.value = "";
    }

    setModuleName("");
    setClassName("");
    setLevelName("");
    setClassName([]);

    setLoading(false);
    fetchData();
  };

  const onClassChange = async (val) => {
    setLoading(true);
    const boardRes = await postApiCall("module/get-by-class", { id: val });
    setModuleList(boardRes.data);
    setLoading(false);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const handleStatusChange = async (rowData, newStatus) => {
    const updatedStatus = newStatus === "Active";
    new Swal({
      title: "Are you sure, you want to make it " + newStatus + "?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("levels/update-active-status", {
          id: rowData.id,
          status: updatedStatus,
        });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    {
      title: "Level",
      field: "name",
    },
    { title: "Order", field: "order" },
    { title: "Module", field: "module_name" },
    { title: "Class", field: "name" },
    {
      title: "Status",
      field: "is_active",
      render: (rowData) => (
        <select
          value={rowData.is_active ? "Active" : "Inactive"}
          onChange={(e) => handleStatusChange(rowData, e.target.value)}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      ),
    },
  ];

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Level</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Level</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* left column */}
              <div className="col-md-12 mt-4">
                {/* general form elements */}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {levelID === "" ? "Add" : "Edit"} Level
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {levelID === "" ? "Select" : "Edit"} Class
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                                onClassChange(e.target.value);
                              }}
                              required
                              value={className}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {levelID === "" ? "Select" : "Edit"} Module
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setModuleName(e.target.value);
                              }}
                              required
                              value={moduleName}
                              name="module_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {moduleList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.module_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <h5>Choose Multiple Levels</h5>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <FormControl fullWidth margin="normal">
                            <Select
                              style={{
                                border: "1px solid gray",
                                padding: "3px 11px",
                                borderRadius: "3px",
                              }}
                              name="name"
                              multiple
                              value={levelName}
                              onChange={(e) => setLevelName(e.target.value)}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {[...Array(20).keys()].map((num) => (
                                <MenuItem key={num + 1} value={num + 1}>
                                  {num + 1}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        {levelID === "" ? "Submit" : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Level"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      //   actions={[
                      //     {
                      //       icon: () => (
                      //         <span style={{ color: "#5656ce" }}>
                      //           <Edit />
                      //         </span>
                      //       ),
                      //       tooltip: "Edit",
                      //       onClick: (event, rowData) => handleEdit(rowData),
                      //     },
                      //     (rowData) => ({
                      //       icon: () => (
                      //         <span style={{ color: "#5656ce" }}>
                      //           <Delete />
                      //         </span>
                      //       ),
                      //       tooltip: "Delete",
                      //       onClick: (event, rowData) => handleDelete(rowData),
                      //     }),
                      //   ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default LevelPage;
